import { httpService } from "./httpService";

/**
 * Platform-owner endpoints. Locked behind backend's platform.admin.enabled
 * flag + SUPER_ADMIN authority. Returns empty list when disabled.
 */
export const getPlatformTenants = async () =>
  httpService({ url: "/platform/tenants", options: { method: "GET" } });

/** Cross-tenant failed outbox events. Platform-owner triage view. */
export const getPlatformFailedOutboxEvents = async () =>
  httpService({ url: "/platform/outbox/failed", options: { method: "GET" } });

/** Cross-tenant usage rollup (drivers vs plan limit, monthly volumes). */
export const getPlatformUsage = async () =>
  httpService({ url: "/platform/usage", options: { method: "GET" } });
